import { useAccount } from '@bnnvara/accounts';
import React from 'react';

import { Bookmarks } from './Bookmarks/Bookmarks';
import { FollowedBrands } from './FollowedBrands/FollowedBrands';
import { EditorialNotificationSettings } from './NotificationSettings/EditorialNotificationSettings';

export function ProfileLoggedIn() {
  const {
    profile: { UID },
  } = useAccount();

  return (
    <>
      <Bookmarks />

      <FollowedBrands />

      <EditorialNotificationSettings UID={UID} />
    </>
  );
}
